import React from 'react';
import { Button } from 'react-bootstrap';
import { format } from 'date-fns';
import './_banners.scss';

export default function BannerWithCTA(props) {
  const { title = '', description = '', btnText = '', btnUrl = '/', openNewTab = false } = props;
  const date = format(new Date(), 'EEEE, MMMM dd');

  return (
    <div className="banner">
      <div className="banner-time">{date}</div>
      <div className="banner-title">{title}</div>
      <div className="banner-desc">{description}</div>
      <Button variant="success" href={btnUrl} target={openNewTab ? '_blank' : ''}>
        {btnText}
      </Button>
    </div>
  );
}
